import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import { RiEyeLine } from "react-icons/ri";
import { API_URL } from "../config";

const Parte = () => {
  const [pdfData, setPdfData] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const fetchFiles = async () => {
    try {
      const res = await axios.get("/api/listPartesPDF");
      setPdfData(res.data);
    } catch (error) {
      console.error("Error cargando archivos:", error);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  // Filtrado independiente
  const filteredData = pdfData.filter((pdf) => {
    let matchesDate = true;
    let matchesSearch = true;

    // Filtrar por fecha si hay valor
    if (filterDate) {
      const selectedDate = filterDate.split("-").reverse().join("-").trim();
      const folderDate = pdf.dateFolder.trim();
      matchesDate = folderDate === selectedDate;
    }

    // Filtrar por nombre si hay valor
    if (searchTerm) {
      matchesSearch = pdf.name.toLowerCase().includes(searchTerm.toLowerCase());
    }

    return matchesDate && matchesSearch;
  });

  return (
    <div className="w-full p-6 min-h-[calc(100vh-6rem)]">
      <h1 className="text-2xl font-bold mb-4">Partes de Averías</h1>

      {/* Filtros */}
      <div className="flex space-x-4 mb-4">
        <input
          type="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          className="border rounded px-2 py-1 text-black"
        />
        <input
          type="text"
          placeholder="Buscar por nombre"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border rounded px-2 py-1 text-black"
        />
      </div>

      <div className="flex justify-between items-center w-full">
        <table className="table-fixed w-full border border-secondary-900 mt-4">
          <thead className="bg-secondary-900">
            <tr>
              <th className="w-2/4 border border-secondary-900 px-4 py-2">
                Fecha
              </th>
              <th className="w-2/4 border border-secondary-900 px-4 py-2">
                Archivo
              </th>
              <th className="w-1/4 border border-secondary-900 px-4 py-2">
                Acción
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((pdf, index) => (
                <tr key={index} className="text-center">
                  <td>{pdf.dateFolder}</td>
                  <td className="px-4 py-2">{pdf.name}</td>
                  <td className="flex items-center justify-center space-x-4 px-4 py-2">
                    <button
                      onClick={() =>
                        window.open(
                          `${API_URL}/uploads/partes/${pdf.dateFolder}/${pdf.name}`,
                          "_blank"
                        )
                      }
                    >
                      <RiEyeLine size={20} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  No se encontraron resultados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Parte;
